/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Shipment } from './shipment';


export interface CameraBuild { 
    orderItemConfigurationId?: string;
    housingTypeId?: string;
    antenna?: CameraBuild.AntennaEnum;
    weight?: number;
    housingLabel?: string;
    uhfCommunication?: boolean;
    failureReason?: string;
    readyForTest?: string;
    testStart?: string;
    manufacturingCompleted?: string;
    configConfirmed?: string;
    packedAt?: string;
    shipment?: Shipment;
    customerRefNo?: string;
    customerContact?: string;
    cameraExtension?: number;
    cameraSideView?: boolean;
}
export namespace CameraBuild {
    export const AntennaEnum = {
        Vhf: 'VHF',
        Uhf: 'UHF',
        VhfAndUhf: 'VHF_AND_UHF'
    } as const;
    export type AntennaEnum = typeof AntennaEnum[keyof typeof AntennaEnum];
}


